







































import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { Component } from "vue-property-decorator";
import RepairEstimateCreateRequestDialog from "./RepairEstimateCreateRequestDialog.vue";
import RepairEstimateCreateStepper, { RepairEstimateSteps } from "./RepairEstimateCreateStepper.vue";

@Component({
  components: {
    RepairEstimateCreateStepper
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class RepairEstimateCreateRequestForm extends RepairEstimateCreateRequestDialog {
  readonly RepairEstimateSteps = RepairEstimateSteps;
}
